export const HISTORY_TYPE = {
    Regular: 1,
    GameSession: 2
};
